export const CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER';
export const GET_PURCHASE_ORDERS = 'GET_PURCHASE_ORDERS';
export const PURCHASE_ORDER_REQUEST = 'PURCHASE_ORDER_REQUEST';
export const UPDATE_PURCHASE_ORDER = 'UPDATE_PURCHASE_ORDER';
export const DELETE_PURCHASE_ORDER = 'DELETE_PURCHASE_ORDER';
export const PURCHASE_ORDER_REQUEST_FAILURE = 'PURCHASE_ORDER_REQUEST_FAILURE';
export const PURCHASE_ORDER_REQUEST_SUCCESS = 'PURCHASE_ORDER_REQUEST_SUCCESS';
export const GET_PURCHASE_ORDERS_PAGE = 'GET_PURCHASE_ORDERS_PAGE';